import React from 'react'
import * as Sentry from '@sentry/node'
function Error({ statusCode }) {
    return (
        <p>
            {statusCode
                ? `An error ${statusCode} occurred on server`
                : 'An error occurred on client'}
        </p>
    )
}

Error.getInitialProps = ({ res, err }) => {
    if (err) {
        Sentry.captureException(err)
    }

    const statusCode = res ? res.statusCode : err ? err.statusCode : 404
    return { statusCode, error: err, namespacesRequired: [] }
}

export default Error
